import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LandingPage from './pages/LandingPage';
import AdminPortfolio from './pages/AdminPortfolio';
import Clients from './pages/Clients';
import ClientProjects from './pages/ClientProjects';
import ProjectDetails from './pages/ProjectDetails';
import LabourVendors from './pages/LabourVendors';
import MaterialVendors from './pages/MaterialVendors';
import VendorDetails from './pages/VendorDetails';
import Subscription from './pages/Subscription';
import Register from './pages/Register';
import AdminUsers from './pages/AdminUsers';
import Enquiries from './pages/Enquiries';
import Partners from './pages/Partners';
import './App.css';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/admin/users"
            element={
              <PrivateRoute>
                <AdminUsers />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <Clients />
              </PrivateRoute>
            }
          />
          <Route
            path="/client/:clientId/projects"
            element={
              <PrivateRoute>
                <ClientProjects />
              </PrivateRoute>
            }
          />
          <Route
            path="/client/:clientId/project/:projectId"
            element={
              <PrivateRoute>
                <ProjectDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/labour-vendors"
            element={
              <PrivateRoute>
                <LabourVendors />
              </PrivateRoute>
            }
          />
          <Route
            path="/material-vendors"
            element={
              <PrivateRoute>
                <MaterialVendors />
              </PrivateRoute>
            }
          />
          <Route
            path="/labour-vendor/:vendorId"
            element={
              <PrivateRoute>
                <VendorDetails vendorType="labour" />
              </PrivateRoute>
            }
          />
          <Route
            path="/material-vendor/:vendorId"
            element={
              <PrivateRoute>
                <VendorDetails vendorType="material" />
              </PrivateRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <PrivateRoute>
                <Subscription />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/portfolio"
            element={
              <PrivateRoute>
                <AdminPortfolio />
              </PrivateRoute>
            }
          />
          <Route
            path="/enquiries"
            element={
              <PrivateRoute>
                <Enquiries />
              </PrivateRoute>
            }
          />
          <Route
            path="/partners"
            element={
              <PrivateRoute>
                <Partners />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
